import React from 'react'

export interface WarnIconProps {
  small?: boolean
  color?: string
  large?: boolean
}

export const WarnIcon: React.FC<WarnIconProps> = ({ small, color, large }) => {
  if (small) {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99984 0.667969L0.666504 14.0013H15.3332L7.99984 0.667969ZM7.99984 3.43469L2.92153 12.668H13.0781L7.99984 3.43469ZM8.6665 10.668V12.0013H7.33317V10.668H8.6665ZM8.6665 10.0013V6.0013H7.33317V10.0013H8.6665Z"
          fill={color}
        />
      </svg>
    )
  }

  if (large) {
    return (
      <svg
        width="160"
        height="160"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1L1 21H23L12 1ZM12 5.15008L4.38254 19H19.6175L12 5.15008ZM13 16V18H11V16H13ZM13 15V9H11V15H13Z"
          fill={color}
        />
      </svg>
    )
  }

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1L1 21H23L12 1ZM12 5.15008L4.38254 19H19.6175L12 5.15008ZM13 16V18H11V16H13ZM13 15V9H11V15H13Z"
        fill={color}
      />
    </svg>
  )
}

export default WarnIcon
